import { Component, Input } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChipDropdownComponent } from '../../../../shared/payee-cases/chip-dropdown/chip-dropdown.component';
import { PayeeFormFieldComponent } from '../../../../shared/payee-form-fields/payee-form-field/payee-form-field.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-payee-case-mokk-payee-case-reference-id-filter',
  templateUrl:
    './payee-case-mokk-payee-case-reference-id-filter.component.html',
  styleUrls: [
    './payee-case-mokk-payee-case-reference-id-filter.component.scss',
  ],
  imports: [
    ChipDropdownComponent,
    PayeeFormFieldComponent,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
})
export class PayeeCaseMokkPayeeCaseReferenceIdFilterComponent {
  @Input({ required: true }) control!: FormControl<string>;

  dropdownOpen = false;

  readonly displayWith = (value: string | null): string => (value ?? '').trim();

  get chipSelected(): string | null {
    return this.control.value;
  }

  closeAfterPaste(): void {
    setTimeout(() => {
      this.dropdownOpen = false;
    });
  }

  clearFilter(): void {
    this.control.patchValue('');
  }
}
